// extracted by mini-css-extract-plugin
export default {"container":"container-bjFk4","imageContainer":"imageContainer-DKrX4","image":"image-yJYPT","title":"title-flHOj"};